import Cookies from 'js-cookie';

const AUTO_LOGIN_KEY = '__AUTO_L';
const REFRESH_TOKEN_KEY = '__REF_T';
const ACCESS_TOKEN_KEY = '__ACC_T';
// const AUTO_EMAIL_KEY = '__AUTO_E';
// const LOGIN_INFO_KEY = '__LOGIN_I';

// 자동 로그인 여부
export const setAutoLogin = (isAutoLogin: boolean): void => {
  !isAutoLogin
    ? Cookies.remove(AUTO_LOGIN_KEY)
    : Cookies.set(AUTO_LOGIN_KEY, isAutoLogin.toString(), {
        expires: 30,
      });
};
export const getAutoLogin = (): boolean => {
  return !!Cookies.get(AUTO_LOGIN_KEY);
};

// 로그인 시, refreshToken 저장
export const setRefreshToken = (token: string): void => {
  Cookies.set(REFRESH_TOKEN_KEY, token, {
    expires: 30,
  });
};
export const getRefreshToken = (): string => {
  return Cookies.get(REFRESH_TOKEN_KEY) as string;
};

export const getAccessToken = (): string => {
  return Cookies.get(ACCESS_TOKEN_KEY) as string;
};
export const setAccessToken = (token: string): void => {
  Cookies.set(ACCESS_TOKEN_KEY, token, {
    // expires: 1 / 24,
  });
};

export const setToken = (token: AccountTokenData): void => {
  setAccessToken(token.accessToken);
  setRefreshToken(token.refreshToken);
};
